import { jsx as g } from "react/jsx-runtime";
import { useState as F, useRef as M, useEffect as w } from "react";
import { useFormContext as H, Controller as O } from "react-hook-form";
import { NeuInput as b } from "@hcahealthcaredpx/neutron-react";
const B = {
  username: /^([A-Z0-9a-z-_]){1,100}$/,
  name: /^([a-zA-Z ',&.-]){0,100}$/,
  suffix: /^([a-zA-Z ',&.-]){0,10}$/,
  address: /^([a-z0-9A-Z ',#.-]){0,50}$/,
  state: /^([a-z0-9A-Z ',#.-]){1,25}$/,
  zipCode: /^\d{5}(?:-\d{4})?$/,
  email: /^[A-Z0-9a-z._%+-]{1,75}@[A-Za-z0-9-]+\.[A-Za-z0-9-.]+$/,
  phone: /^\(\d{3}\)\d{3}-\d{4}$/,
  phoneUnformatted: /^\d{10}$/,
  insuranceId: /^([a-z0-9A-Z ',#.-]){1,50}$/,
  insuranceGroup: /^([a-z0-9A-Z ',#.-]){1,100}$/,
  ssn: /^(?!666|000)\d{3}-(?!00)\d{2}-(?!0{4})\d{4}$/,
  city: /^([a-z0-9A-Z ',#.-]){1,25}$/
}, q = 25, J = [
  {
    label: "Home",
    value: "HOME"
  },
  {
    label: "Cell",
    value: "CELL"
  },
  {
    label: "Work",
    value: "WORK"
  }
], Q = {
  cell: "CELL",
  work: "WORK",
  home: "HOME"
}, ee = {
  phone: "PHONE",
  email: "EMAIL"
}, te = 13, re = "1900-01-01", v = (t) => {
  const e = t.replace(/\D/g, "");
  let r = "";
  return e.length === 0 ? "" : (e.length > 0 && (r += `${e.slice(0, 5)}`), e.length > 5 && (r += `-${e.slice(5, 9)}`), r);
}, D = (t) => {
  if (!t) return "";
  const e = t.replace(/\D/g, "");
  let r = "";
  return e.length === 0 ? "" : (e.length > 0 && (r += `${e.slice(0, 3)}`), e.length > 3 && (r += `-${e.slice(3, 5)}`), e.length > 5 && (r += `-${e.slice(5, 9)}`), r);
}, k = (t) => {
  if (!t)
    return "";
  const e = t.replace(/\D/g, "");
  let r = "";
  return e.length === 0 ? "" : (e.length > 0 && (r += `(${e.slice(0, 3)}`), e.length > 3 && (r += `)${e.slice(3, 6)}`), e.length > 6 && (r += `-${e.slice(6, 10)}`), r);
}, x = (t) => {
  const e = t.replace(/[^a-zA-Z0-9]/g, "");
  return e.length === 0 ? "" : e.length <= 3 ? e : `${e.slice(0, 3)}-${e.slice(3, 7)}`;
}, y = (t) => {
  const e = /[a-zA-Z0-9 ',#.-]/;
  return t.split("").filter((r) => e.test(r)).join("");
}, G = (t) => `${t == null ? void 0 : t.replace(/\D/g, "")}`, W = (t) => t ? t.replace(/[()-]/g, "") : "", d = {
  zip: v,
  phone: k,
  mhoId: x,
  ssn: D,
  city: y,
  numeric: G,
  removeFormats: W
}, Y = (t, e, r) => {
  const l = t.length, c = e.length;
  let n = r;
  return c > l && (n += 1), /[()\-\s]/.test(e[n] ?? "") && (n -= 1), n;
}, ne = ({
  name: t,
  label: e = "",
  labelHidden: r = !1,
  debounce: l = 0,
  tip: c,
  required: n,
  format: i,
  formOnChange: u,
  triggerValidationOnChange: V = !1,
  returnUnmaskedValue: z = !1,
  showInlineError: E = !0,
  showErrorOutline: _ = !0,
  ...R
}) => {
  var N;
  const [Z, h] = F(""), {
    control: L,
    trigger: p,
    watch: I,
    formState: { errors: f }
  } = H(), $ = (N = f == null ? void 0 : f[t]) == null ? void 0 : N.message, A = M(null), C = I(t);
  w(() => {
    h(d[i](C));
  }, [C]);
  const S = (m) => {
    const s = m.currentTarget, o = s.value, a = s.selectionStart ?? 0, T = d[i](o), P = Y(o, T, a);
    return setTimeout(() => {
      A.current && A.current.setSelectionRange(P, P);
    }, 0), T;
  };
  return /* @__PURE__ */ g(
    O,
    {
      name: t,
      control: L,
      render: ({ field: m }) => /* @__PURE__ */ g("div", { className: "w-100", children: /* @__PURE__ */ g(
        b,
        {
          label: e,
          value: Z,
          onChange: (s) => {
            const o = S(s), a = z ? d.removeFormats(s.currentTarget.value) : o;
            h(o), m.onChange(a), u == null || u(a), V && p(t);
          },
          onNeuBlur: () => p(t),
          labelHidden: r,
          debounce: l,
          tip: c,
          required: n,
          invalid: E ? $ : null,
          error: E || _ ? !!$ : null,
          ...R
        }
      ) })
    }
  );
};
export {
  q as C,
  re as E,
  ne as F,
  Q as P,
  B as R,
  J as a,
  ee as b,
  te as c,
  d as f
};
